import styled from 'styled-components';
import { remCalc } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';

export const ProductInfo = styled.p`
  font-size: ${remCalc(14)};
  max-width: 500px;
  margin: ${remCalc(12)} 0;
  color: ${p => p.theme.text.secondary};
  a {
    color: ${p => p.theme.text.secondary};
    text-decoration: underline;
  }
`;

export const AlignRight = styled.div`
  text-align: right;
`;

export const ColoredLink = styled(Link)`
  color: ${p => p.theme.text.callToAction};
  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
